import "./styles/index.css";
import "rc-slider/assets/index.css";
import "react-toastify/dist/ReactToastify.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import QueryProvider from "./providers/QueryProvider";
import SettingsProvider from "./providers/SettingsProvider";
import ThemeBootstrap from "./components/ThemeBootstrap";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-app="wahchanUI"]').forEach((host) => {
        const wrapper = document.createElement("div");
        wrapper.className = "tw-root wahchan-app";
        host.replaceChildren(wrapper);
        createRoot(wrapper).render(
            <StrictMode>
                <QueryProvider>
                    <SettingsProvider>
                        <ThemeBootstrap />
                        <App />
                    </SettingsProvider>
                </QueryProvider>
            </StrictMode>
        );
    });
});
